import {factories} from '@strapi/strapi';
const BASE_URL = process.env.BASE_URL;

export default factories.createCoreService(
  'plugin::telegram-bot.telegram-notification',
  ({strapi}) => ({
    koniBot: strapi.plugin('telegram-bot').service('koniBot'),
    async getDataContent(id: string) {
      const data = await strapi.documents('plugin::telegram-bot.telegram-notification').findOne({
          documentId: id,
          populate: {
            photo: true,
            reply_markup: true,
            telegram_bot: true,
          },
          status: 'published'
        }
      );

      const response = {
        status: false,
        data: null,
        message: "Data not found",
      }

      if (!data) {
        response.message = "Data send not published";
        return response;
      }

      if (!data.photo.url) {
        response.message = "Photo is required";
        return response;
      }

      const photo_url = data.photo.url.startsWith('/') ? `${BASE_URL}${data.photo.url}` : data.photo.url;
      const result = {
        caption: data.caption,
        parse_mode: data.parse_mode,
        reply_markup: {
          inline_keyboard: []
        },
        photo: photo_url,
        botDocumentId: null,
      };

      const {telegram_bot} = data;
      let botUrl = null;
      if (telegram_bot) {
        result.botDocumentId = telegram_bot.documentId;
        const username = telegram_bot.username;
        try {
          const bot = this.koniBot.getBotHandler(username);
          if (!bot) {
            return response;
          }
          botUrl = bot.getMiniApp();
        }
        catch (e) {
          strapi.log.error(e);
          return response;
        }
      }

      if (data.reply_markup && botUrl) {
        const buttons = data.reply_markup.map((reply) => {
          return {
            text: reply.text,
            web_app: {
              url: `${botUrl}${reply.screen ?? ''}`,
            },
          };
        });
        result.reply_markup.inline_keyboard.push(buttons);
      }

      response.status = true;
      response.data = result;
      response.message = "Success";
      return response;
    },
  })
);
